module.exports = __webpack_public_path__ + "img/reference32.8c8ea378.jpg";